module.exports = __webpack_public_path__ + "static/media/logo.9aa8324b.svg";